import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';

function FrontPage_1({ item }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);

  return (
    <div className="h-full w-full overflow-hidden pointer-events-auto">
      <div className="overflow-auto h-full flex flex-col justify-center items-center">
        <div
          className="form flex flex-col m-auto w-full"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 15,
            padding: 10,
          }}
        >
          <img
            src={customization?.logo || process.env.REACT_APP_LOGO}
            alt="logo"
            style={{ width: 'auto', height: staticValues[44], margin: 'auto' }}
          />
          <div
            style={{
              backgroundColor: 'var(--thirdThemeColor)',
              color: 'var(--fourthThemeColor)',
              borderRadius: 10,
              padding: staticValues[10],
              fontSize: staticValues[14],
            }}
          >
            Giriş Yap
          </div>
          <div
            style={{
              marginTop: staticValues[10],
              fontSize: staticValues[14],
              color: 'var(--secondaryThemeColor)',
              fontWeight: 500,
            }}
          >
            Hesabın yok mu?
            <span
              style={{
                fontWeight: 600,
                color: 'var(--secondaryThemeColor)',
                marginLeft: staticValues[5],
              }}
            >
              Kayıt Ol
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FrontPage_1;
